enum EventMessage {
	OverviewMessage = 'overviewMessage',
	Message = 'message',
}
export default EventMessage;
